import { useAuthorization } from 'components/Authorization';
import { useMemo } from 'react';

export const hasSupervisePermission = (roles: Oversea.Token.Payload['roles']) => {
  return roles.some((v) => {
    return v.permissions.some((p) => p.name === 'SUPERVISE');
  });
};

const useRoles = () => {
  const auth = useAuthorization<Oversea.Token.Payload>();
  return useMemo(() => {
    if (!auth.payload?.roles) {
      return {
        roles: [],
        isSuperviser: false,
      };
    }
    const roles = auth.payload?.roles;
    const isSuperviser = hasSupervisePermission(roles);
    return { roles, isSuperviser };
  }, [auth.payload?.roles]);
};

export default useRoles;
